import { Card, Space } from 'antd';
import TotalOrderItem from 'containers/Orders/components/TotalOrderItem';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ERPInformation = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card title={t('transferOrders.erpOrderInformation')}>
      <Space size={15} direction="vertical" className="w-full">
        <TotalOrderItem
          boldValue
          title={t('transferOrders.toNumber')}
          value={data?.transferNumber || '-'}
        />
        <TotalOrderItem
          boldValue
          title={t('transferOrders.wspId')}
          value={data?.wspId || '-'}
        />
        <TotalOrderItem
          boldValue
          title={t('transferOrders.whReceiptId')}
          value={data?.warehouseReceiptNo || '-'}
        />
        <TotalOrderItem
          boldValue
          title={t('transferOrders.batchNumber')}
          value={data?.transferOrderBatchId || '-'}
        />
      </Space>
    </Card>
  );
};

export default ERPInformation;
